import React, { useCallback, useEffect, useRef, useState } from 'react';

import ReactDOM from 'react-dom';

import { userGetProfile } from 'api/endpoints/user-management';
import { ENUM_STEP_PROFILE } from 'constants/enum';
import { TEXT_COMMON, TEXT_PROFILE, TEXT_USER_LIST } from 'constants/string/texts';
import UpdateProfile from 'pages/Users/UserProfile/Form/UpdateProfile';
import { getCodeJapaneseGovernmentsWith } from 'utils/helper';

const Profile = ({ id, close, reloadData, onPageChange }) => {
  const modalProfileRef = useRef(null);
  const [data, setData] = useState(null);
  const [action, setAction] = useState(ENUM_STEP_PROFILE.PROFILE);

  const closeModal = () => {
    close();
  };

  const clickBackdrop = () => {
    modalProfileRef.current.classList.add('animate-fade-out');
    setTimeout(() => {
      modalProfileRef.current.classList.remove('animate-fade-out');
    }, 300);
  };

  const getUserById = async () => {
    if (id) {
      const result = await userGetProfile(id);
      setData({
        ...result.data,
        municipality: getCodeJapaneseGovernmentsWith(result.data?.municipality, false) || '',
      });
    }
  };

  const reload = async () => {
    setAction(ENUM_STEP_PROFILE.PROFILE);
    await getUserById();
    if (onPageChange) {
      const result = await onPageChange(1);
      if (!result) {
        if (reloadData) {
          await reloadData();
        }
      }
    } else if (reloadData) {
      await reloadData();
    }
    window.scrollTo(0, 0);
  };

  const getUserDetail = useCallback(async () => {
    await getUserById();
  }, [id]);

  useEffect(() => {
    getUserDetail();
  }, [getUserDetail]);

  return ReactDOM.createPortal(
    <div id="modal" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-50">
      <div onClick={clickBackdrop} className="fixed inset-0 backdrop" />

      <div ref={modalProfileRef} className="bg-white rounded-sm shadow-lg relative w-120 modal-content">
        {action === ENUM_STEP_PROFILE.PROFILE && (
          <>
            <div className="flex-between-center px-6 py-4 border-b border-white-720 h-14">
              <p className="font-bold">{TEXT_USER_LIST.ACCOUNT_SETTING}</p>
              <div onClick={closeModal}>
                <img className="cursor-pointer" src={require('assets/resources/Close.svg').default} alt="close" width={16} height={16} />
              </div>
            </div>

            <div className="p-6">
              <fieldset>
                <div className="pb-3 mb-4 flex-between-center border-b border-white-720 gap-2 h-16.25">
                  <div>
                    <p className="font-bold text-sm mb-2">{TEXT_PROFILE.EMAIL_ADDRESS}</p>
                    <p className="text-black/85 break-all line-clamp-1">{data?.email}</p>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div className="pb-3 mb-4 flex-between-center border-b border-white-720 gap-2 h-16.25">
                  <div>
                    <p className="font-bold text-sm mb-2">{TEXT_PROFILE.DEPARTMENT}</p>
                    <p className="text-black/85 break-all line-clamp-1">{data?.department}</p>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div className="flex-between-center gap-2">
                  <div>
                    <div>
                      <p className="font-bold text-sm mb-2">{TEXT_PROFILE.MUNICIPALITY}</p>
                      <p className="text-black/85 break-all line-clamp-1">{data?.municipality}</p>
                    </div>
                  </div>
                  <p
                    className="text-sm underline text-primary-346 cursor-pointer whitespace-nowrap"
                    onClick={() => setAction(ENUM_STEP_PROFILE.UPDATE_PROFILE)}
                  >
                    {TEXT_COMMON.EDIT}
                  </p>
                </div>
              </fieldset>
            </div>
            <div className="h-13 border-t border-white-720"></div>
          </>
        )}
        {action === ENUM_STEP_PROFILE.UPDATE_PROFILE && (
          <UpdateProfile data={data} back={() => setAction(ENUM_STEP_PROFILE.PROFILE)} reload={reload} />
        )}
      </div>
    </div>,
    document.body
  );
};

export default React.memo(Profile);
